import type { FaireProductEntity } from "../../entity_types/product";

export const p_xt49b8vta5: FaireProductEntity = {
  token: "p_xt49b8vta5",
  type: "product",
  name: "Ruby Fuchsite Sphere",
  brandToken: "b_qyxxvd286n",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/27227c4c2029b52e562f653507819128c8674c0e9ade3eaaa2c631c21ad5398b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9ac4a4921edb47e7b0322d3d6954d61d3c7fcd0373912294f2a9f34b6629a56.jpeg",
    "https://cdn.faire.com/fastly/f29efeaff86707b2f4d658a6b9ed8d3df65cdc69c3cf04434ab09a4a091d302b.jpeg",
    "https://cdn.faire.com/fastly/8ca2152a4e38157df2fe9f52226d35d55a9bdb38a5783ddf356b349956bfaf3e.jpeg",
    "https://cdn.faire.com/fastly/fd189bf35d973add50a3202a5a0d0dd260ef2cf2a104a6a603cff9c606316249.jpeg",
    "https://cdn.faire.com/fastly/ce993575b752bf99354bb39e974f5d0d74c34fd87270b3a93991362173ab3e02.jpeg",
    "https://cdn.faire.com/fastly/77df1774e4003339da7912826cb62e710a2beebb065e2a72b85b0dfcb7b74cac.jpeg",
    "https://cdn.faire.com/fastly/d44947f1c79b90d122326af0ff70cc06a5ef587deca5c8008917857df6f94ad5.jpeg",
    "https://cdn.faire.com/fastly/2406ca65450afbad31030336d0873d61b14c2ef12f3020917f0087b4b888aa97.jpeg"
  ],
  priceDollars: 54.88,
  description: "Ruby Fuchsite Sphere\n==\nSize:\nDiameter: 55-60 mm\nWeight: 350 grams\n===============\n Ruby Fuchsite sphere is a powerful and beautiful combo crystal—blending the heart-opening energy of Fuchsite with the passionate, fiery essence of Ruby. The result? A stone that's both deeply healing and energizing, especially for matters of the heart and emotional resilience.\n\nRuby brings vitality, courage, and passion. It's connected to the root and heart chakras, helping you stay grounded while opening up to love and confidence.\n\nFuchsite, a shimmering green mica, is all about healing, especially emotional and spiritual healing. It promotes compassion, relaxation, and heart chakra energy.\n===\nNOTE - There will be slight variation in terms of color, texture size, weight etc... as Gemstones have some variations unique to each stone.\nPhotos are representing items from lots. Colors can vary from lot to lot, even inside the lots. This is natural for hand-carved natural gemstone spheres. ",
  tags: [],
  msrpDollars: 109.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:53.118Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
